"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.restoreItem = restoreItem;
const path = __importStar(require("path"));
async function restoreItem(input, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const loomDir = path.join(loomRoot, 'loom');
    const archiveDir = path.join(loomDir, '.archive');
    let rel;
    if ('weaveId' in input && input.weaveId) {
        rel = input.threadId ? path.join(input.weaveId, input.threadId) : input.weaveId;
    }
    else if ('archivedRelPath' in input && input.archivedRelPath) {
        rel = input.archivedRelPath;
    }
    else {
        throw new Error('restoreItem requires either { weaveId, threadId? } or { archivedRelPath }.');
    }
    const source = path.join(archiveDir, rel);
    const restored = path.join(loomDir, rel);
    if (!(await deps.fs.pathExists(source))) {
        throw new Error(`Nothing to restore at .archive/${rel}.`);
    }
    await deps.fs.ensureDir(path.dirname(restored));
    await deps.fs.move(source, restored, { overwrite: false });
    // Prune archive container dirs left empty by the move (e.g. the weave dir
    // after its last archived thread/doc is restored), stopping at .archive/.
    let dir = path.dirname(source);
    while (dir.startsWith(archiveDir + path.sep)) {
        const remaining = await deps.fs.readdir(dir).catch(() => ['keep']);
        if (remaining.length > 0)
            break;
        await deps.fs.remove(dir);
        dir = path.dirname(dir);
    }
    return { source, restored };
}
